import React, { useCallback } from "react";
import styled from "styled-components";
import media from "styled-media-query";
import StyleConfig from "src/constants/StyleConfig";
import { OrderEntity } from "src/firebase/db/Orders";
import { OrderBreadProps } from "src/firebase/db/OrderBreads";
import { UserEntity } from "src/firebase/db/Users";
import ReservationOrderDetailListItem from "src/components/molecules/list/ReservationOrderDetailListItem";

interface Props {
  orders: OrderEntity[];
  orderBread: OrderBreadProps;
  currentDate: Date;
  isFetching: boolean;
  filterByStatus: string;
  filterUsers: (order: OrderEntity) => UserEntity;
  filterPrevOrders: (order: OrderEntity) => OrderEntity[];
  onUpdateIsConfirmed: (id: string, isConfirmed: boolean) => void;
  onUpdateIsCompleted: (id: string, isCompleted: boolean) => void;
}

export const ReservationOrderDetailList = ({ ...props }: Props) => {
  const {
    orders,
    orderBread,
    currentDate,
    isFetching,
    filterByStatus,
    filterUsers,
    filterPrevOrders,
    onUpdateIsConfirmed,
    onUpdateIsCompleted,
  } = props;

  const renderNoMore = useCallback(
    (text: string) => (
      <Styled>
        <div className="nomore">
          <div className="nomore-inner">
            <span>{text}</span>
          </div>
        </div>
      </Styled>
    ),
    []
  );

  if (isFetching) {
    return renderNoMore("読み込み中...");
  }

  if (!orders.length) {
    return renderNoMore("この予約通知には注文が存在しません。");
  }

  return (
    <Styled>
      {orders.map((order) => (
        <ReservationOrderDetailListItem
          key={order.id}
          order={order}
          orderBread={orderBread}
          user={filterUsers(order)}
          prevOrders={filterPrevOrders(order)}
          currentDate={currentDate}
          filterByStatus={filterByStatus}
          onUpdateIsConfirmed={onUpdateIsConfirmed}
          onUpdateIsCompleted={onUpdateIsCompleted}
        />
      ))}
      {renderNoMore("これ以上表示できるデータがありません。")}
    </Styled>
  );
};

const Styled = styled.div`
  .nomore {
    margin-bottom: 24px;

    .nomore-inner {
      position: relative;
      text-align: center;
      padding: 0 12px;

      ${media.greaterThan("small")`
        padding: 0 65px;
      `};

      &:before {
        position: absolute;
        top: calc(50% + 3px);
        left: 0;
        width: 100%;
        height: 1px;
        content: "";
        background: #9a9a9a;

        ${media.greaterThan("small")`
          top: calc(50% - 1px);
        `};
      }

      span {
        position: relative;
        background: ${StyleConfig.COLOR.ECRU};
        padding: 0 6px;
        font-size: 11px;

        ${media.greaterThan("small")`
          font-size: 14px;
          padding: 0 12px;
        `};
      }
    }
  }
`;

export default ReservationOrderDetailList;
